import React, { Component } from "react";
import Slider from "react-slick";
import featureServeIcon01 from "images/index/featureServeIcon01.png";
import featureServeIcon02 from "images/index/featureServeIcon02.png";
import featureServeIcon03 from "images/index/featureServeIcon03.png";
import featureServeIcon04 from "images/index/featureServeIcon04.png";

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    console.log(props)
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "transparent", width: "50px", height: "50px", top: "115px", right: "-54px", textAlign: "left", borderRadius: "50%" }}
            onClick={onClick}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "transparent",fontSize:0, width: "50px", height: "50px", top: "115px", left: "-54px", textAlign: "right", borderRadius: "50%" }}
            onClick={onClick}
        />
    );
}


export default class CustomArrows extends Component {
    render() {
        const { list, tsData } = this.props;
       
        const settings = {
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };
        return (
            <div className="soldier_content_banner">
                <Slider {...settings}>


                    {tsData && tsData.length > 0 ? tsData.map((item, i) => {
                        return (             
                            <a className="convenience_content_slideshow_link" href={item.address} style={{ cursor: "pointer" }} key={i}>
                                <div className="convenience_content_slideshow_img">
                                    <img src={item.bannerUrl} />
                                    <div className="convenience_content_slideshow_txt">{item.bannerTitle}</div>
                                    <div className="convenience_content_slideshow_btn">在线办理</div>
                                </div>
                            </a>
                        )
                    }) : <div className="placeholder"></div>}



                </Slider>
            </div>
        );
    }
}